export const addThousandsSeparatorToString = (str: string): string =>
    str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
